exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drag-handle[data-v-f7699674]{width:30px;display:flex;align-items:center;justify-content:center;cursor:move;padding-right:10px}.drag-icon[data-v-f7699674]{font-size:18px;color:#a0a0a0}", ""]);

// exports
